/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Control_Message_DescInputs */

const en_mk_team_control_message_desc = /** @type {(inputs: Mk_Team_Control_Message_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your messages join subsequent assignments alongside each task’s context and acceptance criteria.`)
};

const id_mk_team_control_message_desc = /** @type {(inputs: Mk_Team_Control_Message_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanmu disertakan pada penugasan berikutnya, bersama konteks dan kriteria selesai setiap tugas.`)
};

/**
* | output |
* | --- |
* | "Your messages join subsequent assignments alongside each task’s context and acceptance criteria." |
*
* @param {Mk_Team_Control_Message_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_control_message_desc = /** @type {((inputs?: Mk_Team_Control_Message_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Control_Message_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_control_message_desc(inputs)
	return en_mk_team_control_message_desc(inputs)
});